import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterByIdPipe } from './filter-by-id.pipe';
import { TimeLeftPipe } from './time-left.pipe';
import { SafePipe } from './safe-url.pipe';
import { OrderByPipe } from './order-by.pipe';
import { DelimiterDisplayPipe } from './delimiter-display.pipe';
import { LineEndingDisplayPipe } from './lineEnding-display.pipe';

@NgModule({
    imports: [ 
        CommonModule 
    ],
    declarations: [
        FilterByIdPipe,
        TimeLeftPipe,
        SafePipe,
        OrderByPipe,
        DelimiterDisplayPipe,
        LineEndingDisplayPipe
    ],
    exports: [
        FilterByIdPipe,
        TimeLeftPipe,
        SafePipe,
        OrderByPipe,
        DelimiterDisplayPipe,
        LineEndingDisplayPipe
    ]
})
export class PipesModule { }
